import { Container, Heading } from '@chakra-ui/react'
import BasePage from '@components/Layouts/BasePage'
import OrgManagementNavigation from '@components/Navigation/OrgManagementNavigation'
import { InvitationsReceived } from '@features/organisations/components/Invitations/InvitationsReceived'
import { MemberOrganisations } from '@features/organisations/components/MemberOrganisations'
import { createFileRoute } from '@tanstack/react-router'

const ManageOrgMembershipRoute = () => (
  <BasePage
    navigation={<OrgManagementNavigation orgId={undefined} />}
    title="Organisations"
  >
    <Container maxW={'75rem'}>
      <MemberOrganisations />
      <Heading as="h2" size="md" mb={5} mt={20}>
        Invitations
      </Heading>
      <InvitationsReceived />
    </Container>
  </BasePage>
)

export const Route = createFileRoute('/_auth/orgs/')({
  component: ManageOrgMembershipRoute,
})
